import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  get1099Prep,
  getScheduleCSummary,
  getFilingDrafts,
  getTaxDeadlines,
  markDraftFiled,
} from '../api/tax';

export function use1099Prep(orgId: string, taxYear: number) {
  return useQuery({
    queryKey: ['admin', 'tax', '1099-prep', orgId, taxYear],
    queryFn: () => get1099Prep(orgId, taxYear),
    staleTime: 2 * 60 * 1000,
  });
}

export function useScheduleCSummary(orgId: string, taxYear: number) {
  return useQuery({
    queryKey: ['admin', 'tax', 'schedule-c', orgId, taxYear],
    queryFn: () => getScheduleCSummary(orgId, taxYear),
    staleTime: 2 * 60 * 1000,
  });
}

export function useFilingDrafts(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'tax', 'filing-drafts', orgId],
    queryFn: () => getFilingDrafts(orgId),
    staleTime: 2 * 60 * 1000,
  });
}

export function useTaxDeadlines(orgId: string) {
  return useQuery({
    queryKey: ['admin', 'tax', 'deadlines', orgId],
    queryFn: () => getTaxDeadlines(orgId),
    staleTime: 5 * 60 * 1000,
  });
}

export function useMarkFiled(orgId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: {
      draftId: string;
      filedVia: 'qbo' | 'manual';
      filedDate?: string;
      evidence?: string;
    }) =>
      markDraftFiled(orgId, args.draftId, {
        filedVia: args.filedVia,
        filedDate: args.filedDate,
        evidence: args.evidence,
      }),
    onSuccess: () => {
      toast.success('Filing marked as filed');
      void queryClient.invalidateQueries({
        queryKey: ['admin', 'tax', 'filing-drafts', orgId],
      });
    },
    onError: (err: Error) => {
      toast.error(`Failed to mark filing: ${err.message}`);
    },
  });
}
